// extracted by mini-css-extract-plugin
module.exports = {"container":"VideoSection_container__345n8","aboutSection":"VideoSection_aboutSection__3YyVJ","videoSection":"VideoSection_videoSection__lXND_"};